import { graph } from 'Model/constants'

export changeTypes = {
  CREATED: 'CREATED'
  UPDATED: 'UPDATED'
  REMOVED: 'REMOVED'
}

opTypes = [
  "remove-from-set"
  "add-to-set"
  "change-relation-key"
  "remove-relation"
  "create-relation"
  "remove-attribute"
  "create-attribute"
  "change-node-id"
  "change-attribute-key"
  "remove-node"
  "create-node"
]

consumeOp = (acc, op) ->
  switch op.action
    when "create-node"
      acc[op.id] = {
        (acc[op.id] ?= {})...
        type: changeTypes.CREATED
      }
    when "create-relation"
      acc[op.sourceId] ?= { type: changeTypes.UPDATED }
      acc[op.sourceId] = {
        acc[op.sourceId]...,
        relations: {
          (acc[op.sourceId].relations || {})...
          [op.key]: [ ((acc[op.sourceId].relations || {})[op.key] || [])..., { type: changeTypes.CREATED, target: op.targetId }]
        }
      }
    when "create-attribute"
      acc[op.sourceId] ?= { type: changeTypes.UPDATED }
      acc[op.sourceId] = {
        acc[op.sourceId]...,
        attributes: {
          (acc[op.sourceId].attributes || {})...
          [op.key]: { value: op.value, type: changeTypes.CREATED }
        }
      }
    when "remove-attribute"
      acc[op.removeId] ?= { type: changeTypes.UPDATED }
      acc[op.removeId] = {
        acc[op.removeId]...,
        attributes: {
          "TYPE": { value: 'Attribute Removed', type: changeTypes.REMOVED }
        }
      }
    when "remove-node"
      acc[op.id] = {
        (acc[op.id] ?= {})...
        type: changeTypes.REMOVED
      }
  acc

export arrangeDiffsByNodes = (ops) ->
  ops.filter((op) ->
    op.graph isnt graph
  ).reduce(consumeOp, {})

getSubsidiaryBranches = (branchHierarchyDict) -> (ref) ->
  _.map(branchHierarchyDict, (val, key) ->
    key if val is ref
  ).filter(Boolean)

getBranchHierarchy = ->
  branches = await Weaver.Branch.list()
  branches.reduce((acc, b) ->
    acc[b.id()] = b.getBaseBranchUid() or undefined # the server returns null
    acc
  , {})

export orderBranchesByHierarchy = ->
  result = []
  allBranches = await getBranchHierarchy()

  getNextSubsidiaries = (branches) ->
    next = branches.map((b) -> getSubsidiaryBranches(allBranches)(b)).flat()
    if next.length > 0
      result.push(next...)
      getNextSubsidiaries(next)

  bases = getSubsidiaryBranches(allBranches)(undefined)
  result.push(bases...)
  getNextSubsidiaries(bases)
  result

export assignBranches = (commits) ->
  branchHierarchy = await orderBranchesByHierarchy()
  heads = commits.filter(({ branches }) -> branches.length > 0)

  branchHierarchy.map((b) ->
    curr = heads.find((h) -> h.branches.indexOf(b) isnt -1)
    return unless curr
    curr.branch = b
    while (next = commits.find(({ uid }) -> curr.parentCommit is uid))
      return if next.branch?
      next.branch = b
      curr = next
  )

